import MyProfileModule from './MyProfileModule';

export default MyProfileModule;
